import React, { useEffect } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { fetchUserProfile } from '../authentication/redux/actions';
import Button from '../../components/button';
import style from './hazard_create.module.scss';
import styles from './hazard_builder.module.scss';
import Step1 from './steps/Step1/Step1';
import Step2 from './steps/Step2/Step2';

const SmsSingleForm = ({
  handleAnswerChanged,
  handleFieldErrorChanged,
  showFormErrors,
  hazardInfo,
  sms_form,
  priorityOptions,
  airport_data,
  requiredMap,
  answers,
  recaptchaRef,
  create,
  fieldsOrdering,
  dataSchema,
  captchaError,
  defaultFieldSchema,
  nomenclature,
  categorySetting,
  singleLocation,
  actionFetchUser,
  smsFormTitle,
  user,
  anonymousSetting,
  enableBadge,
  location_value,
  fileSizeError,
  handleFileSizeValidation,
  datasources,
  selectedLang,
  getLanguageSelect,
  intl,
  errorListMCG
}) => {
    useEffect(() => {
        actionFetchUser();
      }, [actionFetchUser]);
return (
  <div className={styles.box} style={{ background: selectedLang === 'az' ? '#e7eaef' : '', fontFamily: selectedLang === 'az' ? 'calibri' : '' }}>
    <div className={styles.title} style={{ borderBottom: selectedLang === 'az' ? '1px solid #2e406b' : '1px solid #E6EAEE' }}>
      <FormattedMessage
        id={smsFormTitle || 'sms.new.newHazard'}
        values={{ title: smsFormTitle || intl.formatMessage({ id: `sms.nomenclature.${nomenclature?.hazard_title?.replace(/\s+/g, '')}`,
          defaultMessage: nomenclature?.hazard_title || 'Safety Hazard' }) }}
        defaultMessage={smsFormTitle || `${nomenclature?.hazard_title} Report Form `}
      />
      {sms_form?.public_form_settings?.multi_language_settings?.selectedLanguages?.length > 1
      && getLanguageSelect()
      }
    </div>
    <div className={styles.content}>
    {anonymousSetting
    && <div className={styles.check}>
        <input
          name="question"
          id="is_anonymous"
          type="radio"
          onChange={() => handleAnswerChanged('hazardInfo', !hazardInfo.is_anonymous, 'is_anonymous')
                }
          value
          defaultChecked={hazardInfo?.is_anonymous}
        />
        &nbsp;&nbsp;
        <FormattedMessage id="sms.new.anonymous_check" defaultMessage="Anonymous" />
       </div>
    }
      {enableBadge && (
      <div className={styles.check}>
        <input
          name="question"
          type="radio"
          id="badge_info"
          onChange={() => handleAnswerChanged('hazardInfo', !hazardInfo.badge_info, 'badge_info')
                }
          value
          defaultChecked={hazardInfo?.badge_info}
        />
        &nbsp;&nbsp;
        <FormattedMessage id="sms.new.badgeNum" defaultMessage="Badge Number" />
      </div>
      )}
      {(anonymousSetting || enableBadge) && (
      <div className={styles.check}>
        <input
          name="question"
          type="radio"
          id="contact_info"
          onChange={() => handleAnswerChanged('hazardInfo', !hazardInfo.contact_info, 'contact_info')
                }
          value
          defaultChecked={hazardInfo?.contact_info}
        />
        &nbsp;&nbsp;
        <FormattedMessage id="sms.new.contactInfo" defaultMessage="Contact Information" />
      </div>
      )}
      <div className={`${styles.details_form} ${hazardInfo?.is_anonymous ? styles.reportInfoStyle : ''}`}>
        {fieldsOrdering?.map(field => (
          <>
            {fieldsOrdering.indexOf('default_step2') > fieldsOrdering.indexOf(field) && (
              <>
                <Step1
                  onInfoChange={(a, b) => handleAnswerChanged('hazardInfo', b, a)}
                  info={hazardInfo}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  showFormErrors={showFormErrors}
                  orderField={field}
                  defaultFieldSchema={defaultFieldSchema}
                  enableBadge={enableBadge}
                  dataSchemaValue={sms_form?.public_form_settings}
                  selectedLang={selectedLang}
                  airport_data={airport_data}
                />
                <Step2
                  hazardInfo={hazardInfo}
                  category={sms_form?.categories || []}
                  priority={priorityOptions}
                  onInfoChange={(a, b) => handleAnswerChanged('hazardInfo', b, a)}
                  handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  showFormErrors={showFormErrors}
                  schema={sms_form.hazard}
                  map={airport_data}
                  requiredMap={requiredMap}
                  answers={answers}
                  orderField={field}
                  dataSchema={dataSchema}
                  defaultFieldSchema={defaultFieldSchema}
                  nomenclature={nomenclature}
                  locationList={location_value}
                  categorySetting={categorySetting}
                  singleLocation={singleLocation}
                  user={user}
                  publicFormSettings={sms_form?.public_form_settings}
                  fileSizeError={fileSizeError}
                  handleFileSizeValidation={handleFileSizeValidation}
                  datasources={datasources}
                  selectedLang={selectedLang}
                  sms_form={sms_form}
                  errorListMCG={errorListMCG}
                />
              </>
            )}
            {fieldsOrdering.indexOf('default_step2') < fieldsOrdering.indexOf(field) && (
              <>
                <Step1
                  onInfoChange={(a, b) => handleAnswerChanged('hazardInfo', b, a)}
                  info={hazardInfo}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  showFormErrors={showFormErrors}
                  orderField={field}
                  defaultFieldSchema={defaultFieldSchema}
                  enableBadge={enableBadge}
                  dataSchemaValue={sms_form?.public_form_settings}
                  selectedLang={selectedLang}
                  airport_data={airport_data}
                />
                <Step2
                  hazardInfo={hazardInfo}
                  category={sms_form?.categories || []}
                  priority={priorityOptions}
                  onInfoChange={(a, b) => handleAnswerChanged('hazardInfo', b, a)}
                  handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  showFormErrors={showFormErrors}
                  schema={sms_form.hazard}
                  map={airport_data}
                  requiredMap={requiredMap}
                  answers={answers}
                  orderField={field}
                  dataSchema={dataSchema}
                  defaultFieldSchema={defaultFieldSchema}
                  nomenclature={nomenclature}
                  locationList={location_value}
                  categorySetting={categorySetting}
                  singleLocation={singleLocation}
                  user={user}
                  publicFormSettings={sms_form?.public_form_settings}
                  fileSizeError={fileSizeError}
                  handleFileSizeValidation={handleFileSizeValidation}
                  datasources={datasources}
                  selectedLang={selectedLang}
                  sms_form={sms_form}
                  errorListMCG={errorListMCG}
                />
              </>
            )}
          </>
        ))}
      </div>
      {sms_form.public_form_settings?.enable_captcha && (
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={process.env.REACT_APP_RECAPTCHA_TOKEN}
          hl={selectedLang}
        />
            )}
      {captchaError && (
        <div className={style.captchaError}>
          <FormattedMessage id="sms.form.captcha_error" defaultMessage="Captcha is not Checked" />
        </div>
      )}
    </div>
    <div className={styles.footerSingle} style={{ borderTop: selectedLang === 'az' ? '1px solid #2e406b' : '1px solid #E6EAEE' }}>
      <div className={styles.saveBtns}>
        <div className={`${style.footer} ${style.embedded}`}>
          <Button
            action="secondary"
            onClick={() => create()}
            translationID={selectedLang === 'az' ? 'Yarat' : 'inspections.new.create'}
            defaultText={selectedLang === 'az' ? 'Yarat' : 'Create'}
          />
        </div>
      </div>
    </div>
  </div>
);
};

SmsSingleForm.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  user: state.auth.profile
});


const mapDispatchToProps = dispatch => ({
  actionFetchUser: () => {
    dispatch(fetchUserProfile());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SmsSingleForm));
